module.exports = __webpack_public_path__ + "img/icon_recipient.1f06dbd9.svg";